import { Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import MyTabsNested from '../components/MyTabsNested.js';
import { useSelector } from 'react-redux';
import GeneralQuestions from './Questions/GeneralQuestions.js';
import QuestionDetailForm from './Questions/QuestionDetailForm.js';
import { getQuestionData } from '../services/Questions.js';

const QuestionEdit = () => {

  const { alias, questionId } = useParams();
  const [insightTitle, setInsightTitle] = useState();
  const previewEnabled = useSelector(state => state.preview.isEnabled);
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralQuestions, subTabs: [
        { id: "basic", title: "Basic", Component: QuestionDetailForm }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getQuestionData(alias, questionId);

          if (result) {
            setInsightTitle(result?.data?.[0]?.title);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [alias, questionId]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    if (previewEnabled) {
      const pathParts = location.pathname.split('/');
      if (pathParts?.length === 6 && alias) {
        // Redirect to the default tab/subTab
        navigate(`/posts/${alias}/quiz/${questionId}/${tabs[0].id}/${tabs?.[0]?.subTabs?.[0]?.id}`, { replace: true });
      }
    } else {
      navigate(`/posts/${alias}/quiz/${questionId}`, {
        replace: true
      });
    }

  }, [location.pathname, alias, navigate, tabs, previewEnabled, questionId]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
      <Text fontSize={"14px"} fontWeight={"600"} pt={2}>{insightTitle}</Text>
      {previewEnabled ?
        <QuestionDetailForm /> :
        <MyTabsNested orientation="vertical" list={tabs} urlBasePath={`/posts/${alias}/quiz/${questionId}`} includeALias={false} tabSegmentPosition={5} subTabSegmentPosition={6} />
      }
    </Stack>
  );
};

export default QuestionEdit;